// extracted by mini-css-extract-plugin
module.exports = {"AdminAddUser":"AdminAddUser_AdminAddUser__1t08s"};